module.exports = __webpack_public_path__ + "static/img/1sytt.fa96fbf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1sytt.jpg
// module id = g3kY
// module chunks = 0